import React from "react";
import { Box, Typography } from "@mui/material";
import { ComplaintImage } from "../BookingComplaint";
import { useTranslation } from "react-i18next";

interface ComplaintImageBoxProps {
    image: ComplaintImage;
    imageHeight?: number | string;
    imageFit?: "contain" | "cover" | "fill" | "scale-down";
    onClick?: () => void;
    children?: React.ReactNode;
    style?: React.CSSProperties;
    className?: string;
}

export const ComplaintImageBox: React.FC<ComplaintImageBoxProps> = ({
    image,
    imageHeight = 200,
    imageFit = "scale-down",
    onClick,
    children,
    style,
    className
}) => {
    const { t } = useTranslation();
    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                position: "relative",
                borderRadius: 1,
                overflow: "hidden",
                border: "1px solid #dddddd",
                cursor: onClick ? "pointer" : "default",
                ...style
            }}
            className={className}
            onClick={onClick}
        >
            <img
                src={image.url}
                alt={image.name}
                style={{
                    width: "100%",
                    height: imageHeight,
                    objectFit: imageFit,
                    backgroundColor: "#f5f5f5",
                    display: "block"
                }}
            />
            {children}
            <Box sx={{
                p: 1,
                bgcolor: "white",
                borderTop: "1px solid #dddddd",
                boxSizing: "border-box",
                width: "100%",
            }}>
                <Typography variant="body2" noWrap title={image.name}>
                    {image.name}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                    {image.clientId.startsWith("staged_")
                        ? t("complaints.images.notUploadedYet")
                        : image.isInspectionImage
                            ? t("complaints.imageType.inspection")
                            : t("complaints.imageType.uploaded")}
                </Typography>
            </Box>
        </Box>
    );
}; 